import { atom } from "recoil";

export const loginState = atom({
  key:"loginState",
  default: {
    mcd : '',
    auth: '',
    loaded:0
  }
})

export const configState = atom({
  key:"configState",
  default: {
    cid: 'CID00000009',
    name: '두써킷 (정관점)'
  }
})